module.exports = __webpack_public_path__ + "static/media/app-store-white.768e0fd7.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Placeholder/app-store-white.png
// module id = 371
// module chunks = 0